export default __webpack_public_path__ + "static/media/molise.c16192d6.png";